import React from 'react';
import { useParams } from 'react-router-dom';
import { blogPosts } from '../../data/blogData';
import styles from './BlogPostPage.module.css';
import { Helmet } from 'react-helmet';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import Adsense from "../Ads/Adsense";

const BlogPostPage = () => {
  const { postId } = useParams<{ postId: string }>();
  const post = blogPosts.find((p) => p.id === postId);

  if (!post) {
    return <div>게시물을 찾을 수 없습니다.</div>;
  }

  return (
    <div className={styles.container}>
      <Helmet>
        <title>{`${post.title} - Enzo's Toolkit`}</title>
        <meta name="description" content={post.summary} />
      </Helmet>
      <article className={styles.post}>
        <header className={styles.header}>
          <h1>{post.title}</h1>
          <time dateTime={post.date}>{post.date}</time>
        </header>

        <div className={styles.adContainer}>
          <Adsense adClient="ca-pub-9359050149154028" adSlot="6981793359" />
        </div>

        <main className={styles.content}>
          <ReactMarkdown remarkPlugins={[remarkGfm]}>
            {post.content}
          </ReactMarkdown>
        </main>
      </article>
    </div>
  );
};

export default BlogPostPage;
